import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

import {CustomMaterialModule} from '@common/material.module';

import { AdminComponent } from './admin.component';
import { AdminRestService } from './admin-rest.service';

@NgModule({ declarations: [
        AdminComponent
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CustomMaterialModule,
        TranslateModule.forChild({
            extend: true
        })], providers: [AdminRestService] })
export class AdminModule { }
